import * as d3 from "d3";
export const add_color_ratio_data = (data) => {
  let max_seniority_level = data[0].seniority,
    min_seniority_level = data[0].seniority,
    max_no_publications = data[0].scores.publication_count,
    min_no_publications = data[0].scores.publication_count,
    max_citation_count = data[0].scores.citation_count,
    min_citation_count = data[0].scores.citation_count,
    max_h_index = data[0].scores["h-index"] || data[0].scores["h_index"],
    min_h_index = data[0].scores["h-index"] || data[0].scores["h_index"];
  data.map((item) => {
    if (item.seniority > max_seniority_level) {
      max_seniority_level = item.seniority;
    }
    if (item.seniority < min_seniority_level) {
      min_seniority_level = item.seniority;
    }
    if (item.scores.publication_count > max_no_publications) {
      max_no_publications = item.scores.publication_count;
    }
    if (item.scores.publication_count < min_no_publications) {
      min_no_publications = item.scores.publication_count;
    }
    if (item.scores.citation_count > max_citation_count) {
      max_citation_count = item.scores.citation_count;
    }
    if (item.scores.citation_count < min_citation_count) {
      min_citation_count = item.scores.citation_count;
    }
    if (item.scores["h-index"] > max_h_index) {
      max_h_index = item.scores["h-index"];
    }
    if (item.scores["h-index"] < min_h_index) {
      min_h_index = item.scores["h-index"];
    }
  });
  const colorMaker_seniority = d3.scaleLinear(
    [min_seniority_level, max_seniority_level],
    ["#c1fbec", "#00ae7f"]
  );
  const colorMaker_no_publication = d3.scaleLinear(
    [min_no_publications, max_no_publications],
    ["#c1fbec", "#00ae7f"]
  );
  const colorMaker_citation_count = d3.scaleLinear(
    [min_citation_count, max_citation_count],
    ["#c1fbec", "#00ae7f"]
  );
  const colorMaker_h_index = d3.scaleLinear(
    [min_h_index, max_h_index],
    ["#c1fbec", "#00ae7f"]
  );
  return data.map((item) => {
    return {
      ...item,
      seniority_color: colorMaker_seniority(item.seniority),
      seniority_ratio: (item.seniority / max_seniority_level) * 100,
      publication_color: colorMaker_no_publication(
        item.scores.publication_count
      ),
      publication_ratio:
        (item.scores.publication_count / max_no_publications) * 100,
      citation_color: colorMaker_citation_count(item.scores.citation_count),
      citation_ratio: (item.scores.citation_count / max_citation_count) * 100,
      h_index_color: colorMaker_h_index(
        item.scores["h-index"] || item.scores["h_index"]
      ),
      h_index_ratio:
        ((item.scores["h-index"] || item.scores["h_index"]) / max_h_index) *
        100,
    };
  });
};

export const pickColor = () => {
  const colors = ["#ffbe0b", "#8338ec", "#3a86ff", "#06d6a0", "#ff006e"];
  const index = Math.floor(Math.random() * 5);
  return colors[index];
};

export const findMax = (data) => {
  let maxValues = {
    average_seniority: -Infinity,
    citation_count: -Infinity,
    citation_count_per_faculty: -Infinity,
    "h-index": -Infinity,
    no_faculties: -Infinity,
    publication_count: -Infinity,
    no_publications_per_faculty: -Infinity,
    seniority: -Infinity,
  };
  for (let i = 0; i < data.length; i++) {
    let obj;
    if (data[i].hasOwnProperty("score")) {
      obj = data[i].score;
    } else if (data[i].hasOwnProperty("scores")) {
      obj = data[i].scores;
    }
    if (data[i].hasOwnProperty("seniority")) {
      if (data[i]["seniority"] > maxValues.seniority) {
        maxValues.seniority = data[i]["seniority"];
      }
    }
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (key === "citation_count") {
          if (obj.citation_count.total > maxValues.citation_count) {
            maxValues.citation_count = obj.citation_count.total;
          }
        }
        if (key === "average_seniority") {
          if (obj.average_seniority > maxValues.average_seniority) {
            maxValues.average_seniority = obj.average_seniority;
          }
        }
        if (key === "no_faculties") {
          if (obj.no_faculties > maxValues.no_faculties) {
            maxValues.no_faculties = obj.no_faculties;
          }
        }
        if (key === "citation_count_per_faculty") {
          if (
            obj.citation_count_per_faculty.total >
            maxValues.citation_count_per_faculty
          ) {
            maxValues.citation_count_per_faculty =
              obj.citation_count_per_faculty.total;
          }
        }
        if (["h-index", "h_index"].includes(key)) {
          if ((obj["h-index"] || obj["h_index"]).total > maxValues["h-index"]) {
            maxValues["h-index"] = (obj["h-index"] || obj["h_index"]).total;
          }
        }
        if (key === "publication_count") {
          if (obj.publication_count.total > maxValues.publication_count) {
            maxValues.publication_count = obj.publication_count.total;
          }
        }
        if (key === "no_publications_per_faculty") {
          if (
            obj.no_publications_per_faculty.total >
            maxValues.no_publications_per_faculty
          ) {
            maxValues.no_publications_per_faculty =
              obj.no_publications_per_faculty.total;
          }
        } else {
          if (obj[key] > maxValues[key]) {
            maxValues[key] = obj[key];
          }
        }
      }
    }
  }
  return maxValues;
};

export const numberRegex = (str) => {
  const outputString = `${str}`.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  return outputString;
};
